import React from "react";
import classes from "./index.module.scss";

export function LeftContentInvoicesList(props: { title: string }) {
  return (
    <section className={classes.wrapper}>
      <div>
        <div className={classes.firstTitle}>
          <strong>{props.title}</strong>
        </div>

      </div>
    </section>
  );
}
